/*=========================================
  WOMEN FOOTER
  REVEAL V2
=========================================*/

document.addEventListener("DOMContentLoaded", () => {

    const footer = document.querySelector(".footer");

    if (!footer) return;

    const items = footer.querySelectorAll(`
        .dynamic-sidebar__item,
        .footer__block,
        .social__block-container,
        .link-list__block-item,
        .newsletter,
        .newsletter-form,
        .footer__content-bottom
    `);

    if (!items.length) return;

    items.forEach((item, index) => {

        item.style.opacity = "0";

        if (index % 2 === 0) {

            item.style.transform = "translateX(-40px)";

        } else {

            item.style.transform = "translateX(40px)";

        }

        item.style.transition =
            "opacity .8s cubic-bezier(.22,.61,.36,1), transform .8s cubic-bezier(.22,.61,.36,1)";

    });

    const observer = new IntersectionObserver((entries, obs) => {

        entries.forEach(entry => {

            if (!entry.isIntersecting) return;

            items.forEach((item, index) => {

                setTimeout(() => {

                    item.style.opacity = "1";

                    item.style.transform = "translate3d(0,0,0)";

                }, index * 100);

            });

            obs.unobserve(entry.target);

        });

    }, {

        threshold: 0.15

    });

    observer.observe(footer);

});